
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { DollarSign, Clock, CheckCircle, XCircle } from "lucide-react";
import { Plan, ExchangeRate } from "@/types/models";

interface PlanCardProps {
  plan: Plan;
  exchangeRate?: ExchangeRate | null;
}

const PlanCard = ({ plan, exchangeRate }: PlanCardProps) => {
  const priceInBs = exchangeRate ? (plan.price * exchangeRate.usd_to_bs).toFixed(0) : null;

  return (
    <Card className="h-full hover:shadow-lg transition-shadow">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <CardTitle className="text-lg font-semibold text-gray-800">
            {plan.name}
          </CardTitle>
          <Badge
            variant={plan.active ? "default" : "secondary"}
            className={`${plan.active ? "bg-green-500 hover:bg-green-600" : ""} flex items-center gap-1`}
          >
            {plan.active ? (
              <CheckCircle className="h-3 w-3" />
            ) : (
              <XCircle className="h-3 w-3" />
            )}
            {plan.active ? "Activo" : "Inactivo"}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center gap-2">
          <Clock className="h-4 w-4 text-gray-500" />
          <span className="text-sm text-gray-600">Duración:</span>
          <span className="font-medium">{plan.time_duration}</span>
        </div>
        
        <div className="flex items-center gap-2">
          <DollarSign className="h-4 w-4 text-green-600" />
          <span className="text-sm text-gray-600">Precio:</span>
          <div className="font-medium">
            <span className="text-green-600">${plan.price}</span>
            {priceInBs && (
              <span className="text-gray-500 text-sm ml-1">
                ({priceInBs} Bs)
              </span>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PlanCard;
